var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.currentRouterName == 'Home' || _vm.currentRouterName == 'PersonalCenter' ? 'app-main' : 'app-main whiteBg'},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }